import { useAppSelector } from 'hooks';
import { AccessRoles } from 'constants/enums';
import { getUserRoles } from 'store/oauth/reducer';
import { getAllGids } from 'store/groups/selectors';

// A support user, or a clinician on the entry's group
const useCanDeleteClinicalLog = () => {
  const clinicianGids = useAppSelector(getAllGids);
  const userRoles = useAppSelector((state) => getUserRoles(state)) || [];

  return (entryGid?: string) =>
    userRoles.includes(AccessRoles.SUPPORT) || (!!entryGid && clinicianGids.includes(entryGid));
};

export default useCanDeleteClinicalLog;
